import { EnumLanguages } from '@m4u-angular/core/framework/sysenums.enum';
import { LoginService } from '@core/framework/login.service';
import { EnumAutoCreationDocumentTypes, EnumEntityTypes, EnumSystemTypes, EnumUserTypes } from '@dato-proxy/enums';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { SystemOptionEndpoint } from '@dato-proxy/endpoints/systemoption.endpoint';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { Component, ViewChild } from '@angular/core';
import { SystemOption } from '@dato-proxy/entities/systemoption.entity';
import { BaseEntitiesResponse, BaseState, NotificationTemplate } from '@m4u-angular/base/entities/BaseEntities';
import { OptionSourceView } from '@dato-proxy/views/optionsource.view';
import { TestOptionsDialogComponent } from '@dato-dialogs/test-options-dialog/test-options-dialog.component';
import { NotificationTemplateEndpoint } from '@m4u-angular/core/endpoints/notification-template.endpoint';
import { SendDocumentParams } from '@dato-proxy/params/senddocument.param';

class State extends BaseState {
    ReceiptSeriesDataSource: OptionSourceView[];
    InvoiceOneReceiptTemplatesDataSource: OptionSourceView[];
    InvoiceOneReceiptDocCodesDataSource: OptionSourceView[];
    InvoiceOneReceiptDocCodesDataSourceWithDefault: OptionSourceView[];

    InvoiceSeriesDataSource: OptionSourceView[];
    InvoiceOneInvoiceTemplatesDataSource: OptionSourceView[];
    InvoiceOneInvoiceDocCodesDataSource: OptionSourceView[];
    InvoiceOneInvoiceDocCodesDataSourceWithDefault: OptionSourceView[];
    InvoiceOneRefundDocCodesDataSource: OptionSourceView[];
    InvoiceOneRefundDocCodesDataSourceWithDefault: OptionSourceView[];

    OrderSeriesDataSource: OptionSourceView[];
    InvoiceOneOrderTemplatesDataSource: OptionSourceView[];
    InvoiceOneOrderDocCodesDataSource: OptionSourceView[];
    InvoiceOneOrderDocCodesDataSourceWithDefault: OptionSourceView[];

    InvoiceOneDeliveriesDocCodesDataSourceWithDefault: OptionSourceView[];
    InvoiceOneReturnDocCodesDataSource: OptionSourceView[];
    InvoiceOneReturnDocCodesDataSourceWithDefault: OptionSourceView[];

    TestConfigurationButtonItems: any[];
    NotificationTemplates: NotificationTemplate[] = [];
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-options',
    templateUrl: './options.component.html',
    styleUrls: ['./options.component.scss']
})
export class OptionsComponent extends BasePageComponent<SystemOption, State> {

    @ViewChild(TestOptionsDialogComponent) testOptionsDialog: TestOptionsDialogComponent;

    constructor(A: ServiceBagService,
        private systemOptionEndpoint: SystemOptionEndpoint,
        private notificationTemplateEndpoint: NotificationTemplateEndpoint,
        private loginService: LoginService) {
        super(A, 'OptionsComponent', SystemOption, State);
    }

    override OnInitComponent() {
        if (!this.CheckAdmin()) { return; }

        this.InitOptions();

        this.InitReceiptSeries();
        this.InvoiceOneReceiptTemplates();
        this.InitInvoiceOneReceiptDocCodes();

        this.InitInvoiceSeries();
        this.InitInvoiceOneInvoiceTemplates();
        this.InitInvoiceOneInvoiceDocCodes();

        this.InitOrderSeries();
        this.InitInvoiceOneOrderTemplates();
        this.InitInvoiceOneOrderDocCodes();

        this.InitInvoiceOneDeliveriesDocCodes();
        this.InitInvoiceOneRefundDocCodes();
        this.InitInvoiceOneReturnDocCodes();

        this.InitTestConfigurationButtonItems();

        this.LoadNotificationTemplates();
    }

    public IsSBO() { return this.Entity && this.Entity.SystemType === EnumSystemTypes.SBO; }
    public IsLandlord() { return this.Entity && this.Entity.SystemType === EnumSystemTypes.Landlord; }

    public SaveOptions() {
        this.Do(this.systemOptionEndpoint.SaveOptions(this.Entity), true, () => {
            window.location.reload();
        });
    }

    public AutoCreationDocumentTypeChanged() {
        this.InitTestConfigurationButtonItems();
    }

    private CheckAdmin() {
        if (this.UserInfo.UserType !== EnumUserTypes.Admin) {
            this.loginService.DoLogout(undefined);
            this.Navigate(['/system/login']);
            return false;
        }

        return true;
    }

    private InitOptions() {
        this.Do(this.systemOptionEndpoint.GetFull(), false, (response) => {
            this.Entity = response.Entity;
        });
    }

    private InitReceiptSeries() {
        this.Do(this.systemOptionEndpoint.GetReceiptSeries(), false, (response) => {
            this.State.ReceiptSeriesDataSource = response.Entities;
        });
    }

    private InvoiceOneReceiptTemplates() {
        this.Do(this.systemOptionEndpoint.GetInvoiceOneReceiptTemplates(), false, (response) => {
            this.State.InvoiceOneReceiptTemplatesDataSource = response.Entities;
        });
    }

    private InitInvoiceOneReceiptDocCodes() {
        this.Do(this.systemOptionEndpoint.GetInvoiceOneReceiptDocCodes(), false, (response) => {
            this.State.InvoiceOneReceiptDocCodesDataSource = response.Entities;

            const defaultItem = this.GetDefaultPrintItem();
            this.State.InvoiceOneReceiptDocCodesDataSourceWithDefault = this.State.InvoiceOneReceiptDocCodesDataSource;
            this.State.InvoiceOneReceiptDocCodesDataSourceWithDefault.unshift(defaultItem);
            /*this.State.UnsentDeliveriesTemplate = defaultItem.EntryID;*/

        });
    }

    private InitInvoiceOneDeliveriesDocCodes() {
        this.Do(this.systemOptionEndpoint.GetInvoiceOneDeliveriesDocCodes(), false, (response) => {
            this.State.InvoiceOneDeliveriesDocCodesDataSourceWithDefault = response.Entities;

            const defaultItem = this.GetDefaultPrintItem();
            this.State.InvoiceOneDeliveriesDocCodesDataSourceWithDefault = this.State.InvoiceOneDeliveriesDocCodesDataSourceWithDefault;
            this.State.InvoiceOneDeliveriesDocCodesDataSourceWithDefault.unshift(defaultItem);
        });
    }

    private GetDefaultPrintItem() {
        const DefaultItem = new OptionSourceView();
        DefaultItem.EntryID = -1;
        DefaultItem.StrValue = '-1';
        DefaultItem.Text = this.RC("lblDefault");

        return DefaultItem;
    }

    private InitInvoiceSeries() {
        this.Do(this.systemOptionEndpoint.GetInvoiceSeries(), false, (response) => {
            this.State.InvoiceSeriesDataSource = response.Entities;
        });
    }

    private InitInvoiceOneInvoiceTemplates() {
        this.Do(this.systemOptionEndpoint.GetInvoiceOneInvoiceTemplates(), false, (response) => {
            this.State.InvoiceOneInvoiceTemplatesDataSource = response.Entities;
        });
    }

    private InitInvoiceOneInvoiceDocCodes() {
        this.Do(this.systemOptionEndpoint.GetInvoiceOneInvoiceDocCodes(), false, (response) => {
            this.State.InvoiceOneInvoiceDocCodesDataSource = response.Entities;

            const defaultItem = this.GetDefaultPrintItem();
            this.State.InvoiceOneInvoiceDocCodesDataSourceWithDefault = this.State.InvoiceOneInvoiceDocCodesDataSource;
            this.State.InvoiceOneInvoiceDocCodesDataSourceWithDefault.unshift(defaultItem);
            /*this.State.UnsentDeliveriesTemplate = defaultItem.EntryID;*/

        });
    }

    private InitInvoiceOneRefundDocCodes() {
        this.Do(this.systemOptionEndpoint.GetInvoiceOneRefundDocCodes(), false, (response) => {
            this.State.InvoiceOneRefundDocCodesDataSource = response.Entities;

            const defaultItem = this.GetDefaultPrintItem();
            this.State.InvoiceOneRefundDocCodesDataSourceWithDefault = this.State.InvoiceOneRefundDocCodesDataSource;
            this.State.InvoiceOneRefundDocCodesDataSourceWithDefault.unshift(defaultItem);
            /*this.State.UnsentDeliveriesTemplate = defaultItem.EntryID;*/

        });
    }

    private InitOrderSeries() {
        this.Do(this.systemOptionEndpoint.GetOrderSeries(), false, (response) => {
            this.State.OrderSeriesDataSource = response.Entities;
        });
    }

    private InitInvoiceOneOrderTemplates() {
        this.Do(this.systemOptionEndpoint.GetInvoiceOneOrderTemplates(), false, (response) => {
            this.State.InvoiceOneOrderTemplatesDataSource = response.Entities;
        });
    }

    private InitInvoiceOneOrderDocCodes() {
        this.Do(this.systemOptionEndpoint.GetInvoiceOneOrderDocCodes(), false, (response) => {
            this.State.InvoiceOneOrderDocCodesDataSource = response.Entities;

            const defaultItem = this.GetDefaultPrintItem();
            this.State.InvoiceOneOrderDocCodesDataSourceWithDefault = this.State.InvoiceOneOrderDocCodesDataSource;
            this.State.InvoiceOneOrderDocCodesDataSourceWithDefault.unshift(defaultItem);
            /*this.State.UnsentDeliveriesTemplate = defaultItem.EntryID;*/

        });
    }

    private InitInvoiceOneReturnDocCodes() {
        this.Do(this.systemOptionEndpoint.GetInvoiceOneReturnDocCodes(), false, (response) => {
            this.State.InvoiceOneReturnDocCodesDataSource = response.Entities;

            const defaultItem = this.GetDefaultPrintItem();
            this.State.InvoiceOneReturnDocCodesDataSourceWithDefault = this.State.InvoiceOneReturnDocCodesDataSource;
            this.State.InvoiceOneReturnDocCodesDataSourceWithDefault.unshift(defaultItem);
            /*this.State.UnsentDeliveriesTemplate = defaultItem.EntryID;*/

        });
    }

    private InitTestConfigurationButtonItems() {
        this.State.TestConfigurationButtonItems = [
            { text: this.RC('lblSendHebrewDocument').replace('{0}', this.RC('lblReceipt')), onClick: () => { this.SendDocument(EnumEntityTypes.Receipt, EnumLanguages.Hebrew, this.RC('lblReceipt')); } },
            { text: this.RC('lblSendEnglishDocument').replace('{0}', this.RC('lblReceipt')), onClick: () => { this.SendDocument(EnumEntityTypes.Receipt, EnumLanguages.English, this.RC('lblReceipt')); } }
        ];

        if (this.Entity.AutoCreationDocumentType === EnumAutoCreationDocumentTypes.Invoice) {
            this.State.TestConfigurationButtonItems.push({ text: this.RC('lblSendHebrewDocument').replace('{0}', this.RC('lblInvoice')), onClick: () => { this.SendDocument(EnumEntityTypes.Invoice, EnumLanguages.Hebrew, this.RC('lblInvoice')); } });
            this.State.TestConfigurationButtonItems.push({ text: this.RC('lblSendEnglishDocument').replace('{0}', this.RC('lblInvoice')), onClick: () => { this.SendDocument(EnumEntityTypes.Invoice, EnumLanguages.English, this.RC('lblInvoice')); } });
        } else if (this.Entity.AutoCreationDocumentType === EnumAutoCreationDocumentTypes.Order) {
            this.State.TestConfigurationButtonItems.push({ text: this.RC('lblSendHebrewDocument').replace('{0}', this.RC('lblOrder')), onClick: () => { this.SendDocument(EnumEntityTypes.Order, EnumLanguages.Hebrew, this.RC('lblOrder')); } });
            this.State.TestConfigurationButtonItems.push({ text: this.RC('lblSendEnglishDocument').replace('{0}', this.RC('lblOrder')), onClick: () => { this.SendDocument(EnumEntityTypes.Order, EnumLanguages.English, this.RC('lblOrder')); } });
        }
    }

    private SendDocument(entityType: EnumEntityTypes, language: EnumLanguages, documentTypeName: string) {
        this.testOptionsDialog.DocumentTypeName = documentTypeName;
        this.testOptionsDialog.DocumentType = entityType;
        this.testOptionsDialog.Language = language;
        this.testOptionsDialog.ShowDialogShort(() => { });
    }


    private LoadNotificationTemplates() {
        this.Do(this.notificationTemplateEndpoint.GetList(), false, (response: BaseEntitiesResponse<NotificationTemplate>) => {
            this.State.NotificationTemplates = response.Entities;
        });
    }

}
